import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Filter = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 28H15C13.35 28 12 26.65 12 25V18.663C12 17.863 11.687 17.113 11.125 16.538L5.463 10.876C4.525 9.93798 4 8.67598 4 7.33898V5.00098C4 4.45098 4.45 4.00098 5 4.00098H27C27.55 4.00098 28 4.45098 28 5.00098V7.33898C28 8.67698 27.475 9.92698 26.538 10.876L20.875 16.538C20.312 17.101 20 17.863 20 18.663V25C20 26.65 18.65 28 17 28ZM6 5.99998V7.33798C6 8.13798 6.313 8.88798 6.875 9.46298L12.537 15.125C13.487 16.075 14 17.325 14 18.663V25C14 25.55 14.45 26 15 26H17C17.55 26 18 25.55 18 25V18.663C18 17.326 18.525 16.076 19.462 15.126L25.125 9.46398C25.688 8.90098 26 8.13898 26 7.33898V6.00098H6V5.99998Z" />
	</svg>
);

export default Filter;
